

















import { Component, mixins } from '@niknevis/vue-modules'
import { InjectReactive } from 'vue-property-decorator'
import TesTableRow from '@/modules/common/tes-table/mixins/TesTableRow.vue'
import TesTr from '@/modules/common/tes-table/components/shared/TesTr.vue'
import TesTd from '@/modules/common/tes-table/components/shared/TesTd.vue'
import TextEllipsis from '@/modules/shared/components/shared/utils/TextEllipsisOld.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import {
  ContentCampaignCollectionType,
  ContentCampaignCollectionWithModel
} from '@/modules/content-campaign/models/content-campaign-collection.model'
import ContentCampaignItemsCountByStatus
  from '@/modules/content-campaign/components/shared/ContentCampaignItemsCountByStatus.vue'
import PanelContentCampaignActions
  from '@/modules/content-campaign/components/panel/table/PanelContentCampaignActions.vue'
import { PanelContentCampaignRoute } from '@/modules/content-campaign/routes/panel-content-campaign.route'
import { CampaignStatus } from '@/modules/base-campaign/models/base-campaign-resource.model'
import CampaignStatusView from '@/modules/base-campaign/components/shared/CampaignStatusView.vue'

@Component({
  components: {
    TesTd,
    TesTr,
    TextEllipsis,
    BaseButton
  }
})
export default class PanelContentCampaignTableRow extends mixins<TesTableRow>(TesTableRow) {

  constructor(
    private readonly routes: PanelContentCampaignRoute,
  ) {
    super()
  }

  @InjectReactive()
  campaigns!: ContentCampaignCollectionType

  get fixedData(): ContentCampaignCollectionWithModel {
    return {
      default_filters: this.campaigns.default_filters,
      item_statuses: this.campaigns.item_statuses,
      statuses: this.campaigns.statuses,
      types: this.campaigns.types
    }
  }

  columnComponents = {
    items_count: {
      component: ContentCampaignItemsCountByStatus,
      handler: (value, row) => ({
        items_count: value,
        total_counts: row.total_items_count
      })
    },
    status: {
      component: CampaignStatusView,
      handler: (value, row, contentCampaigns) => ({
        status: value,
        statuses: contentCampaigns.statuses
      })
    },
    actions: {
      component: PanelContentCampaignActions,
      handler: (value, row, withData) => ({ campaign: row, withData: withData })
    }
  }

  private getCampaignLinkByState(campaign) {

    if (campaign.status == CampaignStatus.DRAFT) {
      return campaign.step == 1 ?
        this.routes.getStepOne(campaign.id)
        : this.routes.getStepTwo(campaign.id)
    }
    return this.routes.show(campaign.id)
  }

}
